module.exports = __webpack_public_path__ + "static/keystone_admin.08120ec3.png";


//////////////////
// WEBPACK FOOTER
// ./images/keystone_admin.png
// module id = ./images/keystone_admin.png
// module chunks = 1 6